/* global axios */
import ApiClient from '../ApiClient';

// Hang doi yeu cau sao luu cua trang Thong ke > Sao luu.
//
// Endpoint RIENG chu khong nam trong `hieuSuat`: file kia chi DOC so lieu, con
// o day co tao ban ghi va day job. Xem `Api::V2::Accounts::Bonboz::SaoLuuController`.
class SaoLuuAPI extends ApiClient {
  constructor() {
    super('bonboz/sao_luu', { accountScoped: true, apiVersion: 'v2' });
  }

  danhSach() {
    return axios.get(this.url);
  }

  // `loc` la mot object cac o tick; may chu luu thang vao cot jsonb.
  tao({ loai, tu, den, loc } = {}) {
    return axios.post(this.url, { loai, tu, den, loc });
  }

  xoa(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new SaoLuuAPI();
